import { render } from "./ScholarshipRegisterDrawer.vue?vue&type=template&id=72b97451&scoped=true&ts=true"
import script from "./ScholarshipRegisterDrawer.vue?vue&type=script&lang=ts"
export * from "./ScholarshipRegisterDrawer.vue?vue&type=script&lang=ts"

import "./ScholarshipRegisterDrawer.vue?vue&type=style&index=0&id=72b97451&scoped=true&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b97451"]])

export default __exports__